Controller = App.loadClass 'core::Angular/Controller'

class exports.SetPasswordController extends Controller

    constructor: (
        @scope,
        @transitions,
        @state,
        @stateParams,
        @http,
        @q,
        @service,
        auth_response,
        @Routing,
        @Session
    ) ->
        super

        jsr = auth_response.data

        # determine if the user is a cargill user because cargill users have a special info message
        @service.isCargillUser(@stateParams.authentication_code).then (isCargillUser) =>
            @scope.isCargillUser = isCargillUser

        # Log the user out
        @Session.remove 'Authorization'
        @Session.remove 'OriginalUser'
        @Session.remove 'AuthTime'
        @Session.remove 'SelectedCompany-grower'
        @Session.remove 'SelectedCompany-portal'
        @Session.remove 'SelectedCompany-admin'

        @scope.auth_code = @stateParams.authentication_code
        @scope.data_token = @stateParams.data_token
        @scope.is_password_reset = @stateParams.is_password_reset is '1'
        @scope.password_confirm = null
        @scope.password = null
        @scope.auth_verify = null
        @scope.policy = false
        @scope.error = false
        @scope.save = @save
        @scope.cancel = @cancel

        if jsr.status.type is 'error'
            @scope.error = true
        else
            @scope.email = jsr.data.email
            @scope.username = jsr.data.username
            @scope.needs_verification = jsr.data.needs_verification

    cancel: () =>
        @state.go 'logout'

    save: () =>
        @service.save(@scope).then (response) =>
            pretending = response.config.headers.PretendValidate
            if not pretending
                @setAlert response.data.status, [], 2000
                setTimeout () =>
                    @login()
                , 2000


    login: () =>
        @http.post "#{Config.get('api_url')}/auth",
            identifier: @scope.email
            password: @scope.password
        .then (response) =>
            token = response.data.token

            @Session.set 'Authorization', "Bearer #{token}"
            @Session.set 'SafeLink', "Bearer #{token}"
            @Session.set 'OriginalUser', "Bearer #{token}"
            @Session.set 'AuthTime', new Date().getTime()

            # See what user id we are and register ourselves with the websocket connection
            @http.get "#{Config.get('api_url')}/me"
            .then (response) =>
                Raven?.setUserContext response.data
                Socket.whenopen () ->
                    Socket.socket?.send response.data.id

            @Routing.determineDestination(@stateParams)
            return response
        .catch (err) =>
            @setAlert { type: 'error', msg: err.data?.error ? 'Invalid Credentials' }
            return @q.reject err

